import facilityCategories from './FacilityCategory';
import facilityData from './FacilityData';

/**
 * 近つ飛鳥用コード
 * TODO: 汎用的に使える部分はモジュール化したい
 * 
 * @type {IHChikatsuAsuka}
 */
module.exports = class IHChikatsuAsuka extends IH{
  
  constructor(options) {
    super(options);
    this.sortKey = 'kana';
    this.sortOrder = -1;
    this.searchTargetTypes = [];
  }
  
  reset() {
    
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: 'アイコン'
    };
    
    // this.mapOptions = {
    //  
    // }
    
    super.reset();
    
    this.init();
  }
  
  init() {
    var that = this;
    var qs = that.getQueryString();
    if (qs.show_place && qs.show_place !== ''){
      that.firstAction = function(){
        // app?show_place=1,2,3で即検索
        var placeIds = qs.show_place.split(',');
        that.selectPlace(placeIds);
      };
    }else{
      that.firstAction = function(){
        that.searchFromCenter();
        $('#page-search').panel('open');
      };
    }

    $(that).on('ready', () => {
      that.show_direction_on_marker_click = false;

      // 初期値テスト
      // var type = _.find(that.placeTypes, function(t){
      //   return t.name ===  '古墳';
      // });
      // if (type){
      //   type.checked = true;
      // }

      that.renderSearchTypeControlGroup();
      that.readyForPagesAndPanels();
  
      that.renderSearchFacilityControlGroup();

      $(that).on('ihAfterRequestPlaces', function(event, request, places) {
        that.renderFacetCount(request);
      });
      that.renderFacetCount();

      // マーカーポップアップ内容の書き換え
      $(that).on('ihFillMarkerPopup', function(event, place, popup) {
        //var text = '墳丘長 ' + place.attributes['墳丘長（詳細）'] + ', ' + place.attributes['時代'];
        //popup.find('.iw-desc').text(text);

        var obj = {
          1: '学名',
          2: '展示状態',
          3: '綱',
          4: '目',
          5: '科',
          6: '体長',
          7: '体長(事典)',
          8: '平均体長(cm)',
          9: '体重',
          10: '体重(事典)',
          11: '平均体重(kg)',
          12: '分布',
          13: '分布(地域、国)',
          14: '分布(事典)',
          15: '保全状況評価',
          16: 'ワシントン条約',
          17: '絶滅危惧理由',
          18: '食性',
          19: '生活場所',
          20: '活動時間',
          21: '天敵',
          22: 'URL',
          23: 'ランク',
          24: 'エリア',
          25: '新テーマ',
          26: 'おすすめコース'
        };
        
        for (var i in obj){
          var attr = obj[i];
          var text = place.attributes[ attr ];
          
          popup.find('.iw-facet-' + i).html(text);
  
          if(attr != '体長(事典)' && attr != '体重(事典)' && attr != '分布(事典)'){
            popup.find('.iw-facet-' + i).closest('.iw-item').find('.iw-label').text(attr);
          }
          
          if (place.attributes[ attr ]){
            popup.find('.iw-facet-' + i).closest('.iw-item').show();
          }else{
            popup.find('.iw-facet-' + i).closest('.iw-item').hide();
          }
        }

        // 画像拡大
        if (place.image && popup.find('.iw-image-popup').length){
  
          // 画像パスを取得
          var path = place.image;
          
          // 複数の画像パス・画像名称を '|' で分割
          path = path.split('|');
          
          // 画像パスを整形
          for(var i = 0; i < path.length; i++) {
    
            // 改行や空白を削除
            path[i] = path[i].replace(/[\n\r\s]/g, '');
    
            // 画像パスがURLでなければ、ローカルパスを追加
            if (!path[i].match(/^http/)) {
              path[i] = this.place_image_path + path[i];
            }
    
          }
          
          popup.find('.iw-image-popup').show();
          var imagePopupContainer = popup.find('.iw-image-popup .iw-label');
  
          if ($('#image-popup').length === 0){
            
            var imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
            //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
            //var img = $('<img>').appendTo( imagePopup );
            
            // モーダルのヘッダ・フッタの背景色を薄い灰色に
            $('#image-popup').css({'background': '#ddd'});
            
            imagePopup.popup();
  
            // モーダルを閉じるボタン
              $('<button id="closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">閉じる</button>').appendTo(imagePopup);
            $('#closer').on('click', function(){
              imagePopup.popup('close');
            });
            
            // モーダルを閉じるボタンのデザイン
            $('#closer').css({
              'padding': '5px 12px',
              'font-size': '1em'
            });
            
          } else {
            
            // モーダル＋カルーセルが生成済みなら、カルーセル・画像枚数を削除
            $('.carousel').remove();
            $('.bx-wrapper').remove();
            $('#iw-image-count').text('');
            
          }
  
          // 画像枚数が2枚以上なら枚数表示
          if(path.length > 1){
            $('#iw-image-count').text(path.length + '枚');
          }
  
          // カルーセル用のdivを生成してモーダルに追加
          var div = $('<div class="carousel"></div>');
          div.appendTo('#image-popup');
          
          //カルーセル用divのDOMを取得
          var carousel = $('.carousel');
          
          var title = null;
          if(place.type < 1000){
            title = place.name + '（' + place.attributes['綱'] +'）';
          } else {
            title = place.name + '（' + place.area +'）';
          }
          
          // imgを生成してカルーセル用divに追加
          for(var k = 0; k < path.length; k++) {
            
            // カルーセルにimg要素・title属性（動物名）を追加
            $('<div><img src="' + path[k] + '" title="' + title + '"></div>').appendTo(carousel);
          
          }
          
          // カルーセルの設定（画像読み込みの関係で1秒遅れ）
          setTimeout(function(){
  
            carousel.bxSlider({
              slideWidth: 600,
              minSlides: 1,
              maxSlides: 1,
              slideMargin: 5,
              infiniteLoop: false,     // スライドの永久ループを廃止
              hideControlOnEnd: true,  // 最初と最後の写真で、それぞれ前へ・次へボタンを非表示
              // pagerType: 'short',   // ページャをページ数表示→ブレット表示（ボタン）に
              captions: true
            });

            // スライダ部分の高さ最大400px, フッタを45px
            $('.bx-wrapper').css({
              'max-height': '400px',
              'margin': '0 auto 45px'
            });

            // 写真を中央揃え
            $('.bx-wrapper').find('img').css({
              'max-height': '400px',
              'margin-left': 'auto',
              'margin-right': 'auto'
            });
  
            // キャプションの一を写真上部に
            $('.bx-caption').css({
              'bottom': 'initial',
              'bottom': 'auto',
              'top': '0'
            });
  
            // キャプションの文字のデザイン: 影を消す、中央ぞろえ
            $('.bx-caption').find('span').css({
              'text-shadow': 'initial',
              'text-align': 'center',
              'font-size': '1.2em',
              'padding': '4px'
            });
              
            
          }, 1000);
          
          //$('#image-popup').find('img').attr('src', that.place_image_path + place.image);

        }else{
          popup.find('.iw-image-popup').hide();
        }

        if (place.image_label && popup.find('.iw-image-label').length){
          popup.find('.iw-image-label-item').show();
          popup.find('.iw-image-label').text(place.image_label);
        }else{
          popup.find('.iw-image-label-item').hide();
        }
      });
      $(that).on('ihFillSearchResult', function(event, place, item) {
        //var text = '墳丘長 ' + place.attributes['墳丘長（詳細）'] + ', ' + place.attributes['時代'];
        //item.find('.sr-info').text(text);
      });

      $('.js-sort-era').on('click touchend', function(){
        // if (that.sortKey === 'era'){
        //   that.sortOrder = that.sortOrder * -1;
        // }
        that.sortKey = 'length';
        that.sortOrder = 1;
        that.repository.sortKey = 'length';
        $('.js-sort-order').text("");
        $(this).find('.js-sort-order').text(that.sortOrder > 0 ? '▲' : '▼');
        $(this).closest('.ui-controlgroup').find('.ui-btn').removeClass('ui-btn-active');
        $(this).addClass('ui-btn-active');
        that.reSearch();
      });
      $('.js-sort-mound').on('click touchend', function(){
        // if (that.sortKey === 'mound'){
        //   that.sortOrder = that.sortOrder * -1;
        // }
        that.sortKey = 'kana';
        that.sortOrder = -1;
        that.repository.sortKey = 'kana';
        $('.js-sort-order').text("");
        $(this).find('.js-sort-order').text(that.sortOrder > 0 ? '▲' : '▼');
        $(this).closest('.ui-controlgroup').find('.ui-btn').removeClass('ui-btn-active');
        $(this).addClass('ui-btn-active');
        that.reSearch();
      });

      var qs = that.getQueryString();
      if (qs.bigpad){
        $('body').addClass('bigpad');
      }

      $('#quiz-frame').each(function(){
        var frame = $(this);
        frame.width(frame.closest('.panel-content').width());
      });

      function restrictBounds() {
        var values = {lat: [], lng: []};
        for (var i in that.gmarkers.places){
          values.lat.push(that.gmarkers.places[i].position.lat());
          values.lng.push(that.gmarkers.places[i].position.lng());
        }

        var bounds = {
          north: _.min(values.lat),
          south: _.max(values.lat),
          west: _.min(values.lng),
          east: _.max(values.lng),
        };

        var latlng = that.gmap.getCenter();
        var modified = {};
        if (bounds.north > latlng.lat()){
          modified.lat = bounds.north;
        }
        if (bounds.south < latlng.lat()){
          modified.lat = bounds.south;
        }
        if (bounds.west > latlng.lng()){
          modified.lng = bounds.west;
        }
        if (bounds.east < latlng.lng()){
          modified.lng = bounds.east;
        }
        if (modified.lat || modified.lng){
          modified.lat = modified.lat || latlng.lat();
          modified.lng = modified.lng || latlng.lng();
          that.gmap.setCenter(that.map.createLatLng(modified.lat, modified.lng));
        }
      }

      if (qs.bigpad){
        that.gmap.addListener('dragstart', restrictBounds);
        that.gmap.addListener('dragend', restrictBounds);
      }
  
      // 検索パネル「選択を解除」ボタン: ファセット値の選択を全解除
      var self = that;
      $('#clear-facet-value').on('click', function () {
        self.clearFacetSelector();
      });
  
      $('#clear-facility-value').on('click', function () {
        self.clearFacilitySelector();
      });
  
      // 「情報」メニューの各項目を押すと、メニューを閉じる
      $('.js-close-popup').on('click', () => {
        $('#popup-info').popup('close');
      });
      
      // 「現在地」「情報」メニューを開くと、モダール背景に色を着ける
      $('#page-location').popup({
        overlayTheme: "a"
      });
  
      $('#popup-info').popup({
        overlayTheme: "a"
      });

    });
  }
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  
  }

  selectPlace(placeIds){
    var that = this;
    if (!Array.isArray(placeIds)){
      placeIds = [placeIds];
    }
    return that.requestPlaces({places: placeIds}).then(function(res){
      var places = res.places;
      // 自動ズームの場合は移動すると基準位置との位置関係がわからなくなるのでfit-boundsに任せる
      if (!that.fit_bounds){
        if (places.length > 0){
          that.moveMap(places[0].lat, places[0].lng, false);
        }
      }
      if (places.length === 1){
        var marker = that.getPlaceMarker(places[0].id);
        // sakaimap版はポップアップ内のクリックイベントが有効にならないバグあるので修正
        google.maps.event.trigger(marker, 'click');
      }
      that.clearFacilitySelector();
    });
  }
  
  clearFacetSelector(){
    
    var that = this;
    
    $('.js-facet-selector').each(function(){
      
      var c = $(this);
      c.prop('checked', false);
      c.trigger('changeState');
      
      // 選択済のファセット値を非選択にする
      var placetype = $(this).data('placetype');
      that.searchTargetTypes[placetype] = false;
      
      c.checkboxradio();
      c.checkboxradio("refresh");
      
    });
    // ファセット値を全解除状態で再検索
    this.searchFromBaseMarker();
  }
  
  renderFacetCount(request){
    var that = this;
    this.repository.getFacetCount(this.repository.buildFacetQuery(request)).then(function(count){
      _.forEach(count, function(obj){
        var flag = that.isFacetValueChecked(obj.id, obj.facet_id);
        if (obj.count && flag){
          $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').show();
          $('.js-facet-count[data-placetype="'+obj.id+'"]').text(obj.count);
          $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').find('.js-facet-count').show();
          $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').removeClass('ui-disabled');
        }else{
          
          // 該当データが存在しないファセット値を非表示に
          $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').hide();
          
          // $('.js-facet-count[data-placetype="'+obj.id+'"]').text(0);
          // $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').find('.js-facet-count').hide();
          // $('.js-facet-count[data-placetype="'+obj.id+'"]').closest('.ui-checkbox').addClass('ui-disabled');
        
        }
      });
    });
  }
  readyForPagesAndPanels(){
    var sortButton = 50;
    var that = this;
  
    // #home、つまりマップのあるページに戻ってきた時、リサイズイベントを起動する
    $('#home').on('pageshow', function(){
      google.maps.event.trigger(that.gmap, 'resize')
    });
  
    // パネルを開いた時、contentの高さを調整する。fixedにしないと、ウィンドウ全体がスクロールしてしまう
    var openPanel = null;
    var adjuster = 140;
    $('*[data-role=panel]').on('panelopen', function(){
      var outside = $(this).find('.js-outside-content').outerHeight();
      var h = window.innerHeight - adjuster - outside;
      $(this).find('.panel-content').height(h);
      openPanel = $(this);
    });
    $('*[data-role=panel]').on('panelclose', function(){
      openPanel = null;
    });
    $(window).bind("resize", function(event) {
      if (openPanel){
        var outside = openPanel.find('.js-outside-content').outerHeight();
        var h = window.innerHeight - adjuster - outside;
        openPanel.find('.panel-content').height(h);
      }
    });
  
    // パネルを常に開く場合、閉じないようにする。
    $('*[data-role=panel]').on('panelbeforeopen', function(event){
      console.log('beforeopen');
    });
    $('*[data-role=panel]').on('panelbeforeclose', function(event){
      console.log('beforeclose');
    });
    $('*[data-role=panel]').on('panelopen', function(event){
      console.log('open');
    });
    $('*[data-role=panel]').on('panelclose', function(event){
      console.log('close');
      // if (that.isAlwaysPanelShow()){
      //   $(event.target).panel('open');
      // }
    });
  
  }
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes(){
    var types = [];
    for (var i in this.searchTargetTypes){
      if (this.searchTargetTypes[i]){
        types.push(i);
      }
    }
    return types;
  }
  /**
   * 検索画面の項目一覧を描画
   *
   */
  renderSearchTypeControlGroup(){
    var self = this;
    var elem = $('.js-search-type');
    elem.controlgroup({
      create(){
      }
    });
  
    var categories = {};
  
    this.placeType.getAll().forEach(function(type){
      var container = elem.controlgroup('container');
      if (type.category && !categories[type.category.id]){
        
        // ファセットが非表示指定(display: 0)でなければファセットを表示
        if(type.category.display != 0){
          var category = type.category;
          var item = $('<label class="category-label"></label>');
          var categoryCheckbox = $('<input type="checkbox" data-theme="e" data-category="'+category.id+'" class="js-facility-category" />')
          .text(category.name);
  
          // categoryCheckbox.on('change', function(){
          //   var checked = $(this).prop('checked');
          //   $('.js-facet-selector').each(function(){
          //     if ($(this).data('category') === category.id){
          //       // $(this).prop('checked', checked);
          //       $(this).prop('checked', false); // on/offは一貫性ないように見えるので、常に項目内全て非選択
          //       $(this).trigger('changeState');
          //       $(this).checkboxradio();
          //       $(this).checkboxradio("refresh");
          //     }
          //   });
          //   self.searchFromBaseMarker();
          // });
  
          item.append($('<span></span>').text(category.name));
          item.append(categoryCheckbox);
          container.append(item);
          categoryCheckbox.checkboxradio();
          categories[category.id] = category;
        }
        
      }
  
      // 非表示指定の値を持ったファセット値データを取得
      var fitems = _.find(type.category.items, function(itm){
        return itm.id == type.id;
      });
      
      // ファセット値、及びそのファセット値が属するファセットが非表示指定でなければ、ファセット値を表示
      if(type.category.display != 0 && fitems.display != 0){
        var item = $('<label class="js-tooltip" data-target="place-help-'+type.id+'"></label>');
        var count = $('<span class="js-facet-count search-count-circle" data-placetype="'+type.id+'">0</span>');
        var checkbox = $('<input type="checkbox" data-mini="true" class="js-facet-selector" />'); // js-facility-selector
        checkbox.data('category', type.category.id);
        checkbox.data('placetype', type.id);
        checkbox.on('change', function(){
          $(this).trigger('changeState');
          self.searchFromBaseMarker();
        });
        checkbox.on('changeState', function(){
          var placetype = $(this).data('placetype');
          var checked = $(this).get(0).checked;
          self.searchTargetTypes[placetype] = checked;
          
          // 詳細パネル >「選択を解除」ボタンの有効・無効を切り替える
          self.setDisabled();
    
        });
        checkbox.on('click', function(){
          this.blur();
          this.focus();
        });
        if (type.checked){
          checkbox.prop('checked', true);
          checkbox.trigger('changeState');
        }
        // TODO ヘルプ、うまく配置できない
        // if (type.help){
        //   var link = $('<a class="js-tooltip-trigger" href="#" data-role="button" data-theme="b" data-icon="info" data-iconpos="notext" data-inline="true"></a>');
        //   item.append();
        // }
        // <input type="checkbox"
        // data-mini="true"
        // class="js-facility-selector"
        // data-category="<?php echo $key ?>"
        // data-placetype="<?php echo $place->id ?>" <?php if ($place->checked) { ?>checked="checked"<?php } ?> />
        item.append(count);
        item.append(checkbox);
        item.append($(
          // <img src="'+type.icon_min+'" alt="" class="icon-small js-placetype-icon" data-placetype="'+type.id+'" />
          '<span>'+type.name+'</span>'
        ));
        // if (type.help){
        //   var tooltip = $('<div class="js-tooltip-display" data-role="popup" id="place-help-'+type.id+'">');
        //   tooltip.append('<a href="#" data-rel="back" data-role="button" data-theme="a" data-icon="delete" data-iconpos="notext" class="ui-btn-right">Close</a>');
        //   tooltip.append(
        //     $('<h5></h5>')
        //       .append('<img src="'+type.icon_min+'" alt="" class="icon-small" />')
        //       .append($('<span></span>').text(type.name))
        //   );
        //   tooltip.append($('<p></p>').text(type.help));
        //   elem.append(tooltip);
        // }
        container.append(item);
        checkbox.checkboxradio();
      }
      
    });
    
    elem.controlgroup('refresh');
    
    // 詳細パネル >「選択を解除」ボタンの有効・無効を切り替える
    self.setDisabled();
    
  }
  
  isFacetValueChecked(id, cat){
    
    var flag = true;
    
    $('.js-facet-selector').each(function(){
      
      if($(this).prop('checked')){
        if($(this).data('category') == cat && $(this).data('placetype') == id){
          return false;
        } else if($(this).data('category') == cat && $(this).data('placetype') != id) {
          flag = false;
          return false;
        }
      }
      
    });
  
    return flag;
    
  }
  
  setDisabled(){
    
    // 詳細パネル >「選択を解除」ボタンを無効化・グレーアウトする
    $('#clear-facet-value').prop('disabled', true);
    $('#clear-facet').find('.ui-btn-inner').css('color', 'darkgray');
    
    // ファセット値が選択されている時のみ、「選択を解除」ボタンを有効化する
    $('.js-facet-selector').each(function(){
  
      if($(this).prop('checked')){
        $('#clear-facet-value').prop('disabled', false);
        $('#clear-facet').find('.ui-btn-inner').css('color', 'black');
      }
    
    });
    
  }
  
  /**
   * 施設検索メニューを描画
   *
   */
  renderSearchFacilityControlGroup(){
  
    var cat = this.getFacilityCategories()
    
    var self = this;
    var elem = $('.js-search-facility');
    
    elem.controlgroup({
      create(){
      }
    });

    for(var i = 0; i < cat.length; i++){

      var container = elem.controlgroup('container');
      var catLabel = $('<label class="category-label"></label>');
      var categoryCheckbox = $('<input type="checkbox" data-theme="e" data-category="' + cat[i].id +'" class="js-facility-category" />')
      .text(cat[i].name);

      catLabel.append($('<span></span>').text(cat[i].name));
      catLabel.append(categoryCheckbox);
      container.append(catLabel);
      
      categoryCheckbox.checkboxradio();
      
      for(var j = 0; j < cat[i].item.length; j++){
    
        var itemLabel = $('<label class="js-tooltip" data-target="place-help-' + cat[i].item[j].id + '"></label>');
        var c = self.countFacilityData(cat[i].item[j].id);
        var count = $('<span class="js-facility-count search-count-circle" data-placetype="' + cat[i].item[j].id + '">' + c + '</span>');
        var checkbox = $('<input type="checkbox" data-mini="true" class="js-facility-selector" />');
    
        checkbox.data('type', cat[i].item[j].id);
    
        checkbox.on('change', function(){
          $(this).trigger('changeState');
          self.searchFacilities();
      
        });
    
        checkbox.on('click', function(){
          this.blur();
          this.focus();
        });
  
        itemLabel.append(count);
        itemLabel.append(checkbox);
        itemLabel.append($('<img src="../sites/tennoji-zoo/assets/img/pin/' + cat[i].item[j].id + '_min.png" alt="" /> <span>' + cat[i].item[j].name + '</span>'));
        container.append(itemLabel);
        
        checkbox.checkboxradio();
        
      }

    }
    
    elem.controlgroup('refresh');
  
    self.setClearFacilitySelectorDisabled();
  
  }
  
  /**
   * 施設カテゴリを取得
   *
   */
  getFacilityCategories(){
    
    return facilityCategories;
    
  }
  
  /**
   * 施設データを取得
   *
   */
  getFacilityData(){
    
    return facilityData;
    
  }
  
  /**
   * 施設データの件数を取得
   *
   */
  countFacilityData(id){
    
    var data = this.getFacilityData();
    var filtered = _.filter(data, function(d){
      return d.type == id;
    });
    
    return filtered.length;
    
  }
  
  /**
   * 施設データを検索
   *
   */
  searchFacilities(){
    
    var data = this.getFacilityData();
    var checkedFacility = this.getCheckedFacility();
    var result = {};
    
    for(var i = 0; i < Object.keys(checkedFacility).length; i++){
      var filtered = _.filter(data, function(d){
        return d.type == checkedFacility[i];
      });
      Array.prototype.push.apply(result, filtered)
    }
    
    this.map.displayFacilityMarkers(result);
  
    this.setClearFacilitySelectorDisabled();
    
  }
  
  /**
   * 選択された施設カテゴリを取得
   *
   */
  getCheckedFacility(){
    
    var checkedFacility = {};
    var i = 0;
    
    $('.js-facility-selector').each(function(){
      
      if($(this).prop('checked')){
        checkedFacility[i] = $(this).data('type');
        i++;
      }
      
    });
    
    return checkedFacility;
    
  }
  
  /**
   * 施設カテゴリの選択を全て解除
   *
   */
  clearFacilitySelector(){
    
    $('.js-facility-selector').each(function(){
      
      var c = $(this);
      c.prop('checked', false);
      
      c.checkboxradio();
      c.checkboxradio("refresh");
      
    });
    
    this.searchFacilities();
  
  }
  
  /**
   * 施設カテゴリ選択を全て解除ボタンの有効・無効を切替え
   *
   */
  setClearFacilitySelectorDisabled(){
    
    // 詳細パネル >「選択を解除」ボタンを無効化・グレーアウトする
    $('#clear-facility-value').prop('disabled', true);
    $('#clear-facility').find('.ui-btn-inner').css('color', 'darkgray');
    
    // ファセット値が選択されている時のみ、「選択を解除」ボタンを有効化する
    $('.js-facility-selector').each(function(){
      
      if($(this).prop('checked')){
        $('#clear-facility-value').prop('disabled', false);
        $('#clear-facility').find('.ui-btn-inner').css('color', 'black');
      }
      
    });
    
  }
  
};


// WEBPACK FOOTER //
// ./map/js/ih/extend/IHChikatsuAsuka.js